export default "__VITE_ASSET__4eb82a05__"